//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    color: {
      type: String,
      default: "green",
    },
    to: {
      type: String,
      required: true,
    },
  },
  methods: {
    scrollToContact(link) {
      const el = document.getElementById(link);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }

      // Opcional: actualiza el hash para mantener compatibilidad
      history.replaceState(null, null, `/en#${link}`);
    },
  },
};
